enum SalesIncentiveCalculationType {
    PerUnit = 'PerUnit',
    Milestone = 'Milestone',
}

export default SalesIncentiveCalculationType;
